export default __webpack_public_path__ + "static/media/imgLoja05.0dfb395f.png";